// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

function Header() {
  return(
    <Row className="justify-content-md-center text-center" style={{marginBottom: "24px"}}>
      <Col>
        <Link style={{textDecoration: "none", color: "rgb(64, 64, 64)"}} to="/">
          <span style={{fontSize: "3rem"}}>🔥</span>
          <h1 style={{fontSize: "2rem"}}>0xfire</h1>
          <p>the place to ignite your ideas</p>
        </Link>
        <p>
          <Link to="community">community</Link> | <Link to="ventures">ventures</Link> | <Link to="join">join</Link>
        </p>
      </Col>
    </Row>
  )
}

export default Header;